export const inactiveBackgroundColor = '#C4C4C4';
export const inactiveTextColor = '#FFFFFF';
